let control;
let stepVideoComments=1;
let scrollCheckLoadComments = false;
var liveChatCurrentParentId=null;
var MediaSession;

function openVideoComment(videoId, type){

    BSLight.ModalShow('#modal-video-comment');
    addPageToState("modal-video-comment");

    if(type=='video'){
        // initLiveChat(videoId, '.box-right', teyutoVideoPlayer);
       const chatSDK = new TeyutoChatSDK({
            container: document.querySelector('.box-right'),
            videoId: videoId,
            currentUser: (userData.status == "success") ? userData : null,
            isAdmin: false,
            allowGuest: false,
            darkMode: companyThemeDark,
            pusher: pusher,
            player: teyutoVideoPlayer,
            disabledSendButton:true,
            disabledEmoji: true,
            onRegisterClick: () => openModalLogin(),
            firstMessageContainer:  document.querySelector("#live-chat-first-message"),
            showTime: true,
            headers: {
                'channel': CHANNEL_ID,
                'Authorization': userToken
            }
        });
    }
}


var goToNextVideoSem = true;

// stato attivo sulle tab di pagina video E collection (il template
// gestisce solo show/hide delle sezioni; qui lo stato visivo, delegato)
$(document).on('click', '#selectNavigationVideo li, #selectNavigationCollection li', function () {
    $(this).addClass('active').siblings().removeClass('active');
});

let previousMessageButtonHandler;
let previousKeypressHandler;


function gototime(time) {
  teyutoVideoPlayer.currentTime(time);
}

// Commenti (ondemand) / chat (live) INLINE nella pagina video: il chat SDK
// monta direttamente nella .video-side del template (desktop: colonna a
// destra; mobile: sotto al video — stesso markup, layout via live.css).
function initVideoCommentsInline(videoId){
    // idempotente: rientrando più volte nel video NON si devono accumulare
    // né sidebar duplicate né istanze multiple del chat SDK
    var sides = document.querySelectorAll('#video-section-unique .video-side');
    for (var i = 1; i < sides.length; i++) { sides[i].remove(); }
    var container = document.querySelector('#video-section-unique .video-side .box-right');
    if (!container) { return; }
    // reset del container: l'SDK monta da zero, mai in append su un mount vecchio
    container.innerHTML = '<span id="live-chat-first-message"></span>';
    try {
        new TeyutoChatSDK({
            container: container,
            videoId: videoId,
            currentUser: (userData && userData.status == "success") ? userData : null,
            isAdmin: false,
            allowGuest: false,
            darkMode: companyThemeDark,
            pusher: pusher,
            player: teyutoVideoPlayer,
            disabledSendButton: true,
            disabledEmoji: true,
            onRegisterClick: () => openModalLogin(),
            firstMessageContainer: document.querySelector("#live-chat-first-message"),
            showTime: true,
            headers: {
                'channel': CHANNEL_ID,
                'Authorization': userToken
            }
        });
    } catch (e) {
        console.warn('commenti/chat non inizializzati', e);
    }
}


function loadPageVideo(id = null, data = null){ //data is for offline view
    goToNextVideoSem = true;
    currentVIdeoSubtitle = null;

    var isNativeRuntime = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    if (isNativeRuntime && id && (!userData || userData.status != 'success')) {
        openModalLogin();
        return false;
    }

    if (currentAjaxRequest !== null) {
        currentAjaxRequest.abort();
    }

    console.log("sezione video");

    var spinnerHtml = '<svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg>';

    // video aperto da un'altra pagina video (correlati, episodi): il nuovo ne
    // SOSTITUISCE l'entry, quindi se poi non fosse apribile il back
    // salterebbe anche la pagina video corrente e porterebbe in home. La
    // pagina resta intatta finché il nuovo video non è arrivato.
    var switchingVideo = !!id && !!Nav.top() && Nav.top().indexOf('video-') === 0;
    var openVideoPage = function () {
        // layer nello stack PRIMA del render: un video aperto sopra un altro
        // video ne SOSTITUISCE il layer (mai due video impilati)
        pushVideoLayer(id);
        // pagina reale: il contenuto sostituisce la pagina precedente
        // (per le pagine contenuto navigateToPage non tocca lo stack Nav)
        navigateToPage('video');
    };
    var stopSwitchLoading = function () { $('#ty-video-switch-loading').remove(); };

    if (switchingVideo) {
        stopSwitchLoading();
        $('body').append('<div id="ty-video-switch-loading" style="position:fixed;inset:0;z-index:1050;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.35);">' + spinnerHtml + '</div>');
    } else {
        openVideoPage();
        $('#video-section-unique').html('<div id="loading_results_spinner" class="col-md-12 text-center row" style="margin-top:35vh;">' + spinnerHtml + '</div>');
    }

    if(id){
        currentAjaxRequest = $.ajax({
            localCache: true,
            cacheTTL: (1/60),
            type: 'GET',
            url: URL_API2 + '/videos/' + id,
            success: function (json) {
                
                // Notifica per l'utente che sta guardando con i dati mobili, se attiva
                // (navigator.connection esiste solo nell'app: in browser va ignorato)
                try {
                    if (navigator.connection.type !== 'wifi' && userData.notify_watch_without_wifi === true) {
                        window.plugins.toast.showShortBottom('You are playing the content with mobile data');
                    }
                } catch (e) {}
                // Fermo la riproduzione del trailer
                try {
                    teyutoPreviewPlayer.pause();
                    videoTrailerPreviewToggleVolume(true);
                } catch (err) {}
                
                // companyIsFullScreenVideo = false; // !todo rimuovere
                // if (companyIsFullScreenVideo) {
                //     log("video-fullscreen");
                //     screen.orientation.lock('landscape');
                //     setTimeout(function() {
                //         screen.orientation.unlock();
                //     }, 3000);
                // } else {
                //     screen.orientation.unlock();
                // }
                // Successo
                let obj = JSON.parse(json);
                if (Array.isArray(obj)) {
                    obj = obj[0];
                }
                stopSwitchLoading();
                // console.log(JSON.stringify(obj));
                // alert(obj.source);
                if(!obj.source){
                    // entry sotto quella del video appena aperto: serve a
                    // capire se il click veniva dalla collezione stessa
                    var prevLayer = currentPageState.length > 1 ? currentPageState[currentPageState.length-2] : '';

                    //se NON proviene il click dalla collezione stessa: l'entry
                    //del video appena aperta DIVENTA la collection (replace,
                    //nessuna traversata di history, niente entry duplicate)
                    if(obj.collection_id && prevLayer !== 'collection-'+obj.collection_id){
                        try{ Nav.replaceTop('collection-' + obj.collection_id); }catch(err){}
                        openSerieThumb(obj.collection_id, true);
                        return false;
                    }

                    // video non apribile (click dalla collezione stessa o
                    // video senza collection): si torna all'entry precedente
                    // (il popstate ri-renderizza) e POI si apre il paywall.
                    // Da un'altra pagina video si resta su quella: il
                    // paywall si apre sopra il video corrente.
                    if(!switchingVideo){
                        try{ Nav.backIf('video-'); }catch(err){}
                    }
                    if(obj.access == 'not_paid'){
                        Nav.after(function(){ openModalPaymentPreview(obj.collection_id); });
                    }else if(obj.access == 'preview'){
                        Nav.after(function(){ openModalLogin(); });
                    }
                    return false;
                }

                if(switchingVideo){
                    openVideoPage();
                }
                createVideoSection(obj);

                setFirebaseAnalyticsPage("video");
                var fireObj = {
                    "video": {
                        id: id
                    }
                };
                setFirebaseAnalyticsEvent(fireObj);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                stopSwitchLoading();
                // abort volontario (nuovo video o back durante il load):
                // niente compensazioni, ci pensa il flusso che ha abortito
                if (textStatus === 'abort') { return; }
                console.error("Errore nella richiesta AJAX:", textStatus, errorThrown);
                // da un'altra pagina video si resta su quella: login solo
                // se l'utente non è loggato, altrimenti un avviso
                if (switchingVideo) {
                    if (!userData || userData.status != 'success') {
                        openModalLogin();
                    } else {
                        try { open_notifications_toast(translate('ERROR'), "rgba(192, 57, 43, 1)"); } catch (e) {}
                    }
                    return;
                }
                // Errore: si torna all'entry precedente (il popstate
                // ri-renderizza la pagina) e poi si propone il login
                try{ Nav.backIf('video-'); }catch(err){}
                Nav.after(function(){ openModalLogin(); });
            }
        });
    }else{
        //offline video
        createVideoSection(data, true);

        //gli offiline li avvio in full screen
        // screen.orientation.lock('landscape');
        // setTimeout(function() {
        //     screen.orientation.unlock();
        // }, 3000);
    }


}

//glow ambientale dinamico (pagina video e trailer collection): campiona un
//frame del video ogni 3s su uno dei due canvas sfocati e lascia la
//dissolvenza al crossfade CSS tra i due -> passaggio morbido, CPU quasi a
//zero. Se il draw fallisce (es. canvas tainted) resta l'immagine statica
function startAmbientCanvasGlow(timerKey, canvasSel, videoSel, imgSel) {
    try { clearInterval(window[timerKey]); } catch (e) {}
    var front = -1; //nessun canvas ancora visibile
    window[timerKey] = setInterval(function () {
        var canvases = document.querySelectorAll(canvasSel);
        // videoSel punta al media element v10: per drawImage serve il
        // <video> nativo slottato al suo interno (tyInnerVideoEl)
        var videoEl = tyInnerVideoEl(document.querySelector(videoSel));
        if (canvases.length < 2 || !videoEl || videoEl.paused || videoEl.readyState < 2) {
            return;
        }
        try {
            var next = (front === 0) ? 1 : 0;
            var ctx = canvases[next].getContext('2d');
            ctx.drawImage(videoEl, 0, 0, canvases[next].width, canvases[next].height);
            canvases[next].style.opacity = ''; //sfuma verso l'opacità della classe
            if (front >= 0) {
                canvases[front].style.opacity = 0;
            }
            front = next;
            $(imgSel).css('opacity', 0); //il poster statico lascia il posto al glow live
        } catch (err) {
            clearInterval(window[timerKey]);
        }
    }, 3000);
}

function createVideoSection(obj, offline = false){
  if(!obj){
    return false;
  }

  // Unica finestra di sblocco dell'orientamento in tutta l'app (che resta
  // altrimenti portrait: lock in app.js al boot e in nav.js a ogni cambio
  // pagina). Serve solo a intercettare la rotazione del device e trasformarla
  // nel fullscreen del player — vedi initVideoPageRotateFullscreen. Alla
  // chiusura della pagina video destroyVideoPage rimette il lock portrait.
  if (!window.TY_WEB) {
      try { screen.orientation.unlock(); } catch (e) {}
  }

  var videoId = obj.id;
  var imgVideo = obj.img_preview;
  var videoTitle = obj.title;
  var videoCollection = obj.collection;
  var videoDescription = obj.description;
  var videoType = obj.type_video;
  var source = obj.source;
  lastVideoSource = obj.source;

  // id della collection robusto: l'API può esporre 'collection_id' oppure
  // 'collection', e per l'owner in alcune liste vale '0' (stringa, truthy!)
  // = nessuna collection reale. Normalizzato UNA volta e usato ovunque.
  var videoCollectionId = obj.collection_id || obj.collection || null;
  if (videoCollectionId == 0) { videoCollectionId = null; }

  // Colonna commenti/chat: solo se il video li mostra E il canale ha la
  // feature corrispondente configurata (chat per le live, commenti per il
  // resto) — senza feature di canale non va riservato lo spazio a destra.
  var videoHasSidebar = (obj.show_comments === true && offline == false &&
      !!(videoType == 'live' ? companyVideoChat : companyVideoComment));

  // Layout UNICO responsive (nessun wrapper esterno): .video-layout è una
  // griglia a 2 colonne su desktop (player+dettagli | commenti/chat) e una
  // colonna su mobile (la sidebar finisce SOTTO al video). Stili in live.css.
  var htmlVideoTemplate=`
  <div class="contentMedia">
    <div class="video-layout${videoHasSidebar ? '' : ' video-layout-nocomments'}">
    <div class="video-main">
    <div class="playerDiv">

      <img class="video-cinema-lighting" src="${imgVideo}">
      <canvas class="video-cinema-lighting video-cinema-lighting-canvas" width="48" height="27" style="opacity:0;"></canvas>
      <canvas class="video-cinema-lighting video-cinema-lighting-canvas" width="48" height="27" style="opacity:0;"></canvas>

      <div id="video-container-big" class=""></div>
    </div>
    ${(offline == false) ? `
    <div class="footerButtonVideoInfo">
        <button onclick="openModalSetSavedContent(${videoId}, 'video');" type="button" class="button-round controlButtonReminder mr-1 reminder_video${videoId} button-round">
        </button>

        ${(obj.show_likes) ? `
            <button class="button-round btn-set-like controlButtonFavorite mr-1 like${videoId}" onclick="setLikeLive(${videoId}, 'player');">
            </button>
        ` : ''}

        <button class="button-round controlButtonShare mr-1" onclick='shareThisElement("video", ${videoId});'>
            <i class="ri-share-fill font-size-16"></i> ${translate('SHARE')}
        </button>

        <button class="button-round controlButtonShare controlButtonCast mr-1" onclick="requestCastSession();">
            <i class="ri-cast-line font-size-16"></i> ${translate('Cast')}
        </button>

        ${(listDownloadedVideosIds.includes(videoId)) ? `
            <button class="button-round controlButtonShare mr-1">
                <i class="ri-check-line font-size-16"></i> ${translate('Downloaded')}
            </button>
        ` : (obj.access == 'ok') ? `
            <button onclick="startDownloadContentBatch('${videoId}')" class="button-round controlButtonShare mr-1 downloadedVideo-${videoId}">
                <i class="ri-download-2-line font-size-16"></i> ${translate('Download')}
            </button>
        ` : ''}

    </div>

    <div id="box_livecollection_live" class="col-md-12">
        <div style="display:flex;">
        <ul id="selectNavigationVideo" class="channelStyle nav nav-tabs" style="margin:0 auto;">
            <li class="active" onclick="$('.video_det').hide();$('.video_details').show();" data-toggle="tab"><a>${translate('DETAILS')}</a></li>
            ${(videoCollectionId) ? `<li class="video_episodes_tab" onclick="$('.video_det').hide();$('.video_episodes').show();" data-toggle="tab"><a>${translate('EPISODES')}</a></li>` : ''}
            ${(companyRelatedVideo == 1) ? `<li onclick="$('.video_det').hide();$('.video_related').show()" data-toggle="tab"><a>${translate('RELATED_VIDEO')}</a></li>` : ''}
        </ul>
        </div>
    </div>

    <div id="video_details" class="video_det video_details">
        ${ obj.title != obj.collection_title ? `<span style="font-size:14px;" class="gray xbold">${obj.collection_title}</span>`:``}
        <p id="live_title" class="white">${videoTitle}</p>

        <div id="videoFileBox" style="display:none;"></div>

        ${(companyShowVideoView) ? `
        <span class="view_total white mr-1">
            <span class="visitor_label_now">${obj.total_views}</span> ${translate('VIEWS')}
        </span>
        ` : ''}

        <div class="box_video_tags" id="videoTagBox">
        </div>

        <p class="white" id="video_description">${videoDescription}</p>

    </div>

    ${(videoCollectionId) ? `
        <div id="video_episodes" class="video_det video_episodes" style="display:none;">
        <h3 class="video-rel-title white">${translate('EPISODES')}</h3>
        <div class="liveHorizontalListVideo" id="videoSelectedSerie">
        </div>
        </div>
    ` : ``}

    ${(companyRelatedVideo) ? `
        <div id="video_related" class="video_det video_related" style="display:none;">
        <h3 class="video-rel-title white">${translate('RELATED_VIDEO')}</h3>
        <div class="liveHorizontalListVideo" id="videoSelectedRelated">
        </div>
        </div>
    ` : ``}
    ` : ``}
    </div>

    ${videoHasSidebar ? `
    <aside class="video-side${(videoType === 'live') ? ' video-side-live' : ''}">
        <div class="video-side-head white">
            ${(videoType === 'live')
                ? `<i class="ri-broadcast-line"></i> Chat<span class="video-side-live-dot"></span>`
                : `<i class="ri-chat-3-line"></i> ${translate('COMMENTS')}<span class="video-side-count total_comments${obj.id}">${obj.total_comments !== undefined ? obj.total_comments : ''}</span>`}
        </div>
        <div class="box-right video-side-body"><span id="live-chat-first-message"></span></div>
    </aside>
    ` : ``}

    </div>
    </div>
    ${(offline == true) ? `
    <div id="video_details" class="video_det video_details">
        <p id="live_title" class="white">${videoTitle}</p>
    </div>` : ``}
  </div>
  `;
  

  $('#video-section-unique').html(htmlVideoTemplate);

    checkIfContentIsSaved(videoId, 'video');
    checkIfContentIsLiked(videoId, 'player', obj.total_likes);

    // ---- Player Video.js 10 (core condiviso TyPlayer, js/player-core.js):
    // qui resta solo il glue applicativo — resume position, autoplay-next,
    // MediaSession nativa, glow ambientale, orientamento fullscreen.
    try {
        teyutoVideoPlayer.dispose();
    } catch (error) {
    }

    // live non ancora iniziata: nessuna sorgente (arriva col pusher
    // live_start), il player resta sul poster con il countdown sopra.
    // TODO(v10): rimosso l'hack v8 dell'mp3 muto in loop durante l'attesa.
    var liveWaiting = (offline == false) && videoType == 'live' && (obj.livenow == false || obj.livenow == 0);

    teyutoVideoPlayer = TyPlayer.create({
        container: '#video-container-big',
        id: 'teyutoPlayer',
        title: videoTitle,
        poster: imgVideo,
        src: liveWaiting ? null : source,
        type: obj.source_type,
        // ads IMA (integrazione vanilla nel core): ad tag dai dati video
        adTag: (offline == false && obj.ad_vast) ? obj.ad_vast : null,
        opts: {
            autoplay: true,
            live: videoType == 'live'
        }
    });
    var innerVideo = tyInnerVideoEl(teyutoVideoPlayer.mediaEl) || teyutoVideoPlayer.mediaEl;

    // Autoplay migliore-sforzo: l'attributo autoplay non sempre avvia un
    // media creato dopo il load della pagina — tentativo esplicito; se il
    // browser lo blocca resta il big play del core. Mai sopra un ad attivo.
    if(offline == false && !liveWaiting){
        setTimeout(function(){
            try{
                var adOn = document.querySelector('#video-container-big .ty-ad-container.ty-ad-active');
                if(innerVideo.paused && !adOn){
                    var pr = innerVideo.play();
                    if(pr && pr.catch){ pr.catch(function(){}); }
                }
            }catch(e){}
        }, 400);
    }

    lastVideoIdOpened = obj.id;

    startAmbientCanvasGlow(
        'ambientLightTimer',
        '.video-cinema-lighting-canvas',
        '#teyutoPlayer',
        'img.video-cinema-lighting'
    );

    // stato di pausa reale (usato dai flussi di pagina)
    teyutoVideoPlayer.on('play', function() {
        videojsIsPaused = false;
    });
    teyutoVideoPlayer.on('pause', function() {
        videojsIsPaused = true;
    });

    // MediaSession lock-screen (plugin nativo; in browser stub inerte),
    // agganciata agli eventi standard del <video> nativo slottato
    initVideoPageMediaSession(innerVideo, videoTitle, imgVideo);

    // iOS: il pause "di sistema" alla chiusura dell'app non deve fermare
    // la riproduzione voluta dall'utente
    initVideoPagePauseGuard();

    // fullscreen: bottone della skin stock v10; su nativo il fullscreen
    // blocca l'orientamento in landscape (comportamento storico dell'app)
    initVideoPageFullscreenOrientation(innerVideo);

    // rotazione fisica del device (solo nativo): landscape → entra in
    // fullscreen, portrait → esce
    initVideoPageRotateFullscreen();

    // Chromecast: play/pause/seek/sottotitoli del player replicati sul
    // ricevitore (cast.js). Se una sessione è già attiva il video parte
    // subito in cast; il bottone Cast sta tra le azioni sotto al video.
    if (offline == false && !liveWaiting) {
        bindPlayerToCast(teyutoVideoPlayer, source, obj.source_type);
    } else {
        bindPlayerToCast(teyutoVideoPlayer, null, null);
    }

    if(offline == false){

        // analytics di riproduzione: ripristinate (usano l'adapter TyPlayer)
        initPlayerStat(teyutoVideoPlayer, videoId);
        // popup in-player (skip/link/testo): componente nuovo del core
        TyPlayer.attachPopups(teyutoVideoPlayer, obj.popups);
        // commenti/chat inline nella .video-side del template
        if (videoHasSidebar) {
            initVideoCommentsInline(videoId);
        }

        if( (videoType == 'ondemand' || videoType == 'live') && (companyVideoComment || companyVideoChat)){
            $('.videoTabChat').show();
        }

        if(videoType == 'ondemand'){
            // resume dalla posizione dell'ultima visione
            playVideoAtLastSeen(teyutoVideoPlayer, obj.id);
            // autoplay del prossimo video sull'evento 'ended'
            // (userData può essere ancora null se il video arriva da deep-link
            // prima di user_data: senza guardia il TypeError uccideva tutto il
            // resto del render — correlati e tag inclusi)
            if(userData && userData.autoplay){
                autoplayNextVideo(teyutoVideoPlayer, obj.id);
            }
        }

        if(videoType == 'live'){
            //clean cashe for live streaming
            clearLocalStorageKeys(obj.id);
            //notifiche pusher
            var channel = pusher.subscribe("live_" + obj.id);
            channel.bind('notification', function (data) {
                var text = JSON.parse(data);

                if (text.type == "live_start") {
                    teyutoVideoPlayer.src({
                        type: 'application/x-mpegURL',
                        src: obj.source
                    });
                    teyutoVideoPlayer.loop(false);
                    teyutoVideoPlayer.play();
                    setCastSource(obj.source, 'application/x-mpegURL');
                    $('#countdown-live-stream').remove();
                }
                if (text.type == "live_stop") {
                    //
                }
                if (text.type == "currently_users") {
                    $(".visitor_label_now").html(text.val);
                }
            });

            if (liveWaiting) {
                countdownVideoLive(obj.date);
            }
        }

        if(companyRelatedVideo){
            getContentsHorizontal(URL_API2+"/contents/videos?f=get_video&id="+videoId+"&option=related_videos", 1, "#video_related");
        }

        // episodi della collection del video (come la webapp), con
        // l'episodio corrente evidenziato (ultimo parametro)
        if(videoCollectionId){
            try {
                getContentsHorizontal(URL_API2 + "/contents/videos?collection_id=" + videoCollectionId, 1, "#video_episodes", null, null, null, obj.id);
            } catch (e) {}
        }

        createAttachementsSection("#videoFileBox", obj.attachments);
        createTagsSection("#videoTagBox", obj.tags_key);

    }

}

// Allegati del video (bottoni con estensione + nome, come la webapp)
function createAttachementsSection(el, obj) {
    if (obj && obj.length > 0) {
        var html = '';
        obj.forEach(function (file) {
            var ext = String(file.file || '').split('.').pop();
            var url = file.file;
            if (url == null || !url) {
                url = '/register?ref=/video?w=' + getUrlParameter('w');
            }
            html += `<a class="button-round mr-1 mt-1" target="_blank" href="${url}"><span class="label label-primary" style="text-transform:uppercase;">${ext}</span> ${file.name}</a>`;
        });
        $(el).html(html);
        $(el).show();
    }
}

// MediaSession lock-screen (nativo): posizione, stato e metadata agganciati
// agli eventi standard del <video> nativo. In browser lo stub è inerte.
//
// Il plugin Android (cordova-plugin-media-session) ricostruisce la notifica
// a ogni chiamata e non è thread-safe: aprendo un video sopra un altro
// (correlati, episodi) il vecchio <video> continuava a inviare eventi e ogni
// video ri-registrava i 6 action handler a servizio già attivo. Quindi:
// handler registrati UNA volta (agiscono sul video corrente), eventi dei
// player già sostituiti ignorati, metadata una sola volta per video e nessuno
// stato 'none' (che scollega il servizio) prima della prima riproduzione.
var tyMediaSession = { el: null, stopped: false, handlersBound: false };

function initVideoPageMediaSession(videoEl, videoTitle, imgVideo){
    try {
        MediaSession = cordova.plugins.MediaSession;
    } catch (e) {
        MediaSession = {
            setPositionState: function () {},
            setPlaybackState: function () {},
            setMetadata: function () {},
            setActionHandler: function () {}
        };
    }
    if (!videoEl) { return; }

    tyMediaSession.el = videoEl;
    tyMediaSession.stopped = false;

    var hasPlayed = false;
    var metadataSent = false;
    var isCurrent = function () { return tyMediaSession.el === videoEl; };

    var updatePositionState = function () {
        if (!isCurrent()) { return; }
        MediaSession.setPositionState({
            position: videoEl.currentTime,
            duration: videoEl.duration,
            playbackRate: videoEl.playbackRate
        });
    };

    var updatePlaybackState = function () {
        if (!isCurrent() || !hasPlayed) { return; }
        MediaSession.setPlaybackState({
            playbackState: tyMediaSession.stopped ? 'none' : (videoEl.paused ? 'paused' : 'playing')
        });
    };

    ['durationchange', 'seeked', 'ratechange', 'play', 'pause'].forEach(function (ev) {
        videoEl.addEventListener(ev, updatePositionState);
    });

    videoEl.addEventListener('play', function () {
        if (!isCurrent()) { return; }
        hasPlayed = true;
        tyMediaSession.stopped = false;
        updatePlaybackState();
        if (!metadataSent) {
            metadataSent = true;
            MediaSession.setMetadata({
                title: videoTitle,
                artist: companyName,
                artwork: [{ src: imgVideo, sizes: '512x512', type: 'image/png' }]
            });
        }
    });
    videoEl.addEventListener('pause', updatePlaybackState);

    if (tyMediaSession.handlersBound) { return; }
    tyMediaSession.handlersBound = true;

    var withCurrent = function (fn) {
        return function (details) {
            var el = tyMediaSession.el;
            if (!el) { return; }
            try { fn(el, details || {}); } catch (e) {}
        };
    };
    MediaSession.setActionHandler({ action: 'play' }, withCurrent(function (el) {
        el.play();
    }));
    MediaSession.setActionHandler({ action: 'pause' }, withCurrent(function (el) {
        el.pause();
    }));
    MediaSession.setActionHandler({ action: 'seekto' }, withCurrent(function (el, details) {
        el.currentTime = details.seekTime;
    }));
    MediaSession.setActionHandler({ action: 'seekforward' }, withCurrent(function (el, details) {
        el.currentTime = el.currentTime + (details.seekOffset || 30);
    }));
    MediaSession.setActionHandler({ action: 'seekbackward' }, withCurrent(function (el, details) {
        el.currentTime = el.currentTime - (details.seekOffset || 30);
    }));
    MediaSession.setActionHandler({ action: 'stop' }, withCurrent(function (el) {
        tyMediaSession.stopped = true;
        el.pause();
    }));
}

// individua se il pause è volontario o meno, per prevenire il bug iOS del
// pause di sistema alla chiusura dell'app. Il listener di documento è unico
// (bound una sola volta) e legge sempre il player corrente.
var tyPauseGuard = { reallyPaused: true, lastInteraction: 0, bound: false };
function initVideoPagePauseGuard(){
    tyPauseGuard.reallyPaused = false;
    tyPauseGuard.lastInteraction = Date.now();

    teyutoVideoPlayer.on('play', function () {
        tyPauseGuard.lastInteraction = Date.now();
        tyPauseGuard.reallyPaused = false;
    });
    teyutoVideoPlayer.on('pause', function () {
        // pausa entro 1s da un'interazione = voluta dall'utente
        tyPauseGuard.reallyPaused = (Date.now() - tyPauseGuard.lastInteraction) <= 1000;
    });
    teyutoVideoPlayer.on('touchend', function () {
        tyPauseGuard.lastInteraction = Date.now();
    });

    if (!tyPauseGuard.bound) {
        tyPauseGuard.bound = true;
        document.addEventListener("pause", function () {
            if (!tyPauseGuard.reallyPaused && lastVideoIdOpened) {
                try { teyutoVideoPlayer.play(); } catch (e) {}
            }
        }, false);
    }
}

// Su nativo il fullscreen del player (bottone della skin v10, evento
// standard fullscreenchange) blocca l'orientamento in landscape; all'uscita
// lo sblocca. Listener di documento unico.
var tyFullscreenOrientationBound = false;
function isIOSNativeApp(){
    if (typeof isNativeApp !== 'function' || !isNativeApp()) { return false; }
    try {
        return window.Capacitor && window.Capacitor.getPlatform &&
            window.Capacitor.getPlatform() === 'ios';
    } catch (e) {
        return false;
    }
}

// Nudge dello scroll: la UIScrollView sottostante la WKWebView può restare
// con gli insets dello scroll indicator "sporchi" dopo un fullscreen video
// nativo (bug noto WebKit: gli obscured insets impostati per il player a
// tutto schermo non vengono sempre ripuliti alla chiusura, anche con
// contentInsetAdjustmentBehavior=never). Un micro-scroll (avanti e indietro
// di 1px) costringe la UIScrollView a ricalcolarli — il solo dispatch di un
// evento resize non è sufficiente, perché il problema è nella UIScrollView
// nativa sotto la WebView, non nel layout CSS della pagina.
function nudgeIOSScrollIndicators(){
    try {
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
        window.scrollBy(1, 0);
        window.scrollBy(-1, 0);
    } catch (e) {}
}

// Forza un resize della WebView iOS: alcuni cambi di layout viewport
// (fullscreen nativo del player, rotate-fullscreen) non emettono resize da
// soli, lasciando dimensioni "stale" che disallineano elementi calcolati
// sulla viewport (es. il thumb della scrollbar nativa spostato dal bordo
// verso il centro). Due frame + un timeout di sicurezza assicurano che gli
// handler responsive leggano le dimensioni finali anche se iOS aggiorna il
// layout con un frame di ritardo. shouldRun (opzionale) annulla i refresh
// differiti se la condizione che li ha richiesti non è più valida (es.
// elemento video smontato nel frattempo).
function refreshIOSLayoutViewport(shouldRun){
    var refresh = function () {
        if (typeof shouldRun === 'function' && !shouldRun()) { return; }
        window.dispatchEvent(new Event('resize'));
        nudgeIOSScrollIndicators();
    };

    requestAnimationFrame(function () {
        requestAnimationFrame(refresh);
    });
    setTimeout(refresh, 250);
    // secondo giro più tardivo: su alcuni device la UIScrollView riapplica
    // gli insets sbagliati con un ritardo maggiore del frame successivo
    setTimeout(refresh, 600);
}

function refreshIOSLayoutAfterFullscreen(innerVideo){
    refreshIOSLayoutViewport(function () { return innerVideo.isConnected; });
}

function initVideoPageFullscreenOrientation(innerVideo){
    if (isIOSNativeApp() && innerVideo &&
        !innerVideo.dataset.tyFullscreenRecoveryBound) {
        innerVideo.dataset.tyFullscreenRecoveryBound = '1';
        innerVideo.addEventListener('webkitendfullscreen', function () {
            // Il fullscreen nativo di Safari iOS non aggiorna
            // document.fullscreenElement né emette fullscreenchange.
            if (!document.body.contains(innerVideo)) { return; }
            try {
                var lockP = screen.orientation.lock('portrait');
                if (lockP && lockP.catch) { lockP.catch(function () {}); }
            } catch (e) {}
            refreshIOSLayoutAfterFullscreen(innerVideo);
        });
    }

    if (tyFullscreenOrientationBound) { return; }
    tyFullscreenOrientationBound = true;

    var onChange = function () {
        if (typeof isNativeApp === 'function' && !isNativeApp()) { return; }
        var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        var container = document.getElementById('video-container-big');
        try {
            if (fsEl && container && container.contains(fsEl)) {
                var p = screen.orientation.lock('landscape-primary');
                if (p && p.catch) { p.catch(function () {}); }
            } else {
                screen.orientation.unlock();
                // uscita dal Fullscreen API vero: stesso bug degli altri due
                // percorsi (rotate-fullscreen, webkitendfullscreen), qui non
                // ancora coperto — la UIScrollView/layout viewport possono
                // restare sporchi e la scrollbar nativa risultare spostata
                // dal bordo su TUTTE le pagine successive
                if (isIOSNativeApp()) { refreshIOSLayoutViewport(); }
            }
        } catch (e) {}
    };
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
}

// ======================= [rotate-fullscreen] =========================
// L'app è SEMPRE portrait (lock in app.js al boot e in nav.js a ogni cambio
// pagina). L'unica eccezione è la pagina video, che sblocca l'orientamento
// (vedi createVideoSection) al solo scopo di intercettare la rotazione: NON
// per mostrare la pagina in landscape. Quando il device è girato la classe
// ty-rotate-fs su <body> nasconde tutto (navbar, header, dettagli, chat) e
// lascia solo il player a tutto schermo — stili in mobile.css. La webview è
// già ruotata dal sistema, quindi niente transform: il rendering è nativo.
// Il Fullscreen API vero non viene usato: da un evento di rotazione, senza
// gesto utente, nel WebView non entra davvero.
function setVideoRotateFullscreen(active){
    if (active === document.body.classList.contains('ty-rotate-fs')) { return; }
    document.body.classList.toggle('ty-rotate-fs', active);
    try { active ? StatusBar.hide() : StatusBar.show(); } catch (e) {}
    // uscita dal rotate-fullscreen (rientro automatico in portrait o back):
    // su iOS il layout viewport della WebView può restare con dimensioni
    // stale dopo la rotazione, disallineando la scrollbar nativa nelle
    // pagine successive (es. una collezione aperta subito dopo)
    if (!active && isIOSNativeApp()) {
        refreshIOSLayoutViewport();
    }
}

// Uscita "volontaria" dal fullscreen (back): il device può essere ancora
// fisicamente girato, quindi non basta togliere la classe — si rimette il
// lock portrait per riportare subito la webview dritta. Lo sblocco viene
// riarmato solo quando il telefono torna davvero verticale, altrimenti il
// rilascio del lock rimanderebbe in landscape (e in fullscreen) all'istante.
var tyPortraitReleaseTimer = null;
var tyPortraitTiltHandler = null;
function exitVideoRotateFullscreen(){
    setVideoRotateFullscreen(false);
    tyLockPortrait();
    armPortraitRelease();
}

function tyLockPortrait(){
    if (window.TY_WEB) { return; }
    try {
        var p = screen.orientation.lock('portrait');
        if (p && p.catch) { p.catch(function () {}); }
    } catch (e) {}
}

// Riarmo dello sblocco: l'accelerometro (deviceorientation) dice quando il
// telefono è tornato verticale. Su iOS gli eventi possono non arrivare mai
// senza permesso esplicito: in quel caso decide il fallback a tempo.
function armPortraitRelease(){
    // un riarmo per volta: il precedente va smontato, o a ogni uscita dal
    // fullscreen resterebbe appeso un listener in più
    clearTimeout(tyPortraitReleaseTimer);
    if (tyPortraitTiltHandler) {
        window.removeEventListener('deviceorientation', tyPortraitTiltHandler);
        tyPortraitTiltHandler = null;
    }

    var release = function () {
        clearTimeout(tyPortraitReleaseTimer);
        if (tyPortraitTiltHandler) {
            window.removeEventListener('deviceorientation', tyPortraitTiltHandler);
            tyPortraitTiltHandler = null;
        }
        // solo se siamo ancora sulla pagina video: altrove l'app resta portrait
        if (!window.TY_WEB && lastVideoIdOpened) {
            try { screen.orientation.unlock(); } catch (e) {}
        }
    };
    tyPortraitTiltHandler = function (ev) {
        if (ev.gamma === null || ev.gamma === undefined) { return; }
        // |gamma| è l'inclinazione sull'asse lungo: vicino a 0 = telefono dritto
        if (Math.abs(ev.gamma) < 25) { release(); }
    };
    window.addEventListener('deviceorientation', tyPortraitTiltHandler);
    tyPortraitReleaseTimer = setTimeout(release, 5000);
}

// Rotazione fisica del device (solo nativo, solo pagina video): landscape →
// fullscreen, portrait → esce. Listener unico, registrato una volta sola
// insieme al guard che fa chiudere il fullscreen al tasto indietro.
var tyRotateFullscreenBound = false;
function initVideoPageRotateFullscreen(){
    if (tyRotateFullscreenBound) { return; }
    tyRotateFullscreenBound = true;

    var onRotate = function () {
        if (typeof isNativeApp === 'function' && !isNativeApp()) { return; }

        var type = (screen.orientation && screen.orientation.type) || '';
        var landscape = type ? type.indexOf('landscape') === 0
                             : Math.abs(window.orientation || 0) === 90;

        // il rientro in portrait toglie SEMPRE il fullscreen, anche se nel
        // frattempo la pagina video è stata smontata
        if (!landscape) { setVideoRotateFullscreen(false); return; }

        // ingresso: solo con un video aperto in pagina e niente modali sopra
        // (BSLight marca con 'in' quelle aperte: il player le coprirebbe)
        if (!lastVideoIdOpened) { return; }
        if (document.querySelector('.modal.in')) { return; }
        // se il player è già nel fullscreen VERO (bottone della skin) basta quello
        try {
            if (teyutoVideoPlayer.isFullscreen()) { return; }
            var inner = tyInnerVideoEl(teyutoVideoPlayer.mediaEl);
            if (inner && inner.webkitDisplayingFullscreen) { return; }
        } catch (e) {}

        setVideoRotateFullscreen(true);
    };

    if (screen.orientation && screen.orientation.addEventListener) {
        screen.orientation.addEventListener('change', onRotate);
    } else {
        window.addEventListener('orientationchange', onRotate);
    }

    // indietro in fullscreen: chiude il fullscreen e resta sulla pagina video
    try {
        Nav.addBackGuard(function () {
            if (!document.body.classList.contains('ty-rotate-fs')) { return false; }
            exitVideoRotateFullscreen();
            return true;
        });
    } catch (e) {}
}

function playVideoAtLastSeen(player, videoId){
    const checkUserDataStatus = () => {
        if (typeof userData !== 'undefined' && userData && userData.status !== undefined) {
            if (userData.last_seen) {
                const foundObject = userData.last_seen.find(obj => obj.video_id === videoId);
                if(foundObject){
                    if (foundObject.last_second && foundObject.last_second > 5) {
                        player.currentTime(foundObject.last_second);
                    }
                }
            }
            clearInterval(intervalId);
        }
    };
    const intervalId = setInterval(checkUserDataStatus, 100);
}

function createTagsSection(el, obj){
    var html = '';
    if (obj && obj.length > 0) {
        obj.forEach(tag => {
            html += `<label onclick="clickedBrowseAll('','${tag.id}', '${tag.title.replace(/'/g, "\\'")}');" class="label-tag label mr-1">${tag.title}</label>`;
        }); 
        $(el).html(html);
    }
}